import { render, staticRenderFns } from "./ModalTaxDesc.vue?vue&type=template&id=3a43a540&scoped=true"
import script from "./ModalTaxDesc.vue?vue&type=script&lang=js"
export * from "./ModalTaxDesc.vue?vue&type=script&lang=js"
import style0 from "./ModalTaxDesc.vue?vue&type=style&index=0&id=3a43a540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43a540",
  null
  
)

export default component.exports